<template>
    <div class="">
        <van-nav-bar title="加入须知" />
        <div class="joininfo">
            <div class="title">普惠商家合作须知</div>
            <div class="content" style="white-space: pre-line" v-html="txt"></div>
            <van-checkbox v-model="radio" checked-color="#ff6633" class="agree">已阅读并同意《机构入驻协议》</van-checkbox>
            <div class="apply" @click="goApply">立即申请</div>
        </div>
    </div>
</template>

<script>
import { getAgreement } from '../api/index';
export default {
    data() {
        return {
            radio: false,
            txt: '',
            text: '1.商家必须为经过工商、质监、卫生等相关管理部门批准成立的合法经营机构。\n 2.在本行业中属于优质企业或信誉度高、口碑较好的企业。（未受到工商、卫生等主管部门的行政处罚）\n 3.具有良好信用，能自觉遵守维护签约项目的市场秩序和形象。\n 4.提供的商品和服务具有稳定性和公开性，无投机取巧行为，能为提供的商品和服务质量负责。\n 5.须具备成熟、规范的管理能力，能对合作业务进行广泛宣传，并在营业场所醒目位置挂放合作标识及相关宣传资料，并配合工会做好相关宣传工作。\n 6.服务范围（分店）能够覆盖全市主要城区（三区两县）。 7.在同等条件下，优先选择让利较大的普惠商家合作。\n 8.在同等条件下，建立工会组织的企业优先入选。\n 9.须具备支持云闪付付款的收单机具或码牌（或能自主完成支持云闪付付款的条件），并能配合市总开展相应活动。'
        };
    },
    methods: {
        onClickLeft() {},
        goApply() {
            if (this.radio) {
                this.$router.push({ path: '/Apply', query: { isAdd: true } });
                // this.$router.push({ path: '/Banner/edit', query: { id: file.id } });
            } else {
                this.$toast({
                    message: '请先同意商家申请加入协议',
                    position: 'center'
                });
            }
        },
        getAgreement() {
            getAgreement().then((res) => {
                this.txt = res.data[0].protocolContent;
            });
        }
    },
    mounted() {
        this.getAgreement();
    }
};
</script>

<style lang="scss" scoped>
.orange {
    color: #ff6633;
}
.joininfo {
    padding: 10px 20px;
    .title {
        font-size: 20px;
        font-weight: 800;
        text-align: center;
    }
    .content {
        font-size: 16px;
        font-weight: 400;
        word-break: break-all;
        word-wrap: break-word;
    }
    .agree {
        font-size: 13px;
        margin: 10px 0;
    }
    .apply {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 40px;
        font-size: 17px;
        background: #ff6633;
        border-radius: 6px;
        color: #fff;
    }
}
</style>
